<mat-drawer-container class="example-container">
    <mat-drawer-content>
        <div class="encounter-container mt-10">
            <table
              mat-table
              [dataSource]="dataSource"
              class="mat-elevation-z8 table-encounter"
            >


            <ng-container matColumnDef="Appointno">
              <th mat-header-cell *matHeaderCellDef class="custom-header">{{"EncounterPage.Appointment" |translate}}</th>
              <td
                mat-cell
                class="col-norwap"
                *matCellDef="let element; let index = index"
              >
              <div>
                <span class="encounter-number">{{ element.appNo }}</span><br>
                <span class="encounter-token">{{ element.bookingType }}</span>
              </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="DepartmentName">
              <th mat-header-cell *matHeaderCellDef class="custom-header">
                 {{"adt.speciality" |translate}}
              </th>
              <td mat-cell class="col-nowrap" *matCellDef="let element" 
              [ngClass]="{
                'vip-background': element.isVip,
                'doctor-long-name': element.doctorName.length > 50
              }">
                <div>
                  <strong class="Age-font">{{ element.specialty }}</strong><br>
                  <div class="name-div">
                  <span class="name-contain">{{ element.doctorName }}</span>
                  </div>
                </div>
              </td>
            </ng-container>
      
            <ng-container matColumnDef="Gender/Age">
              <th mat-header-cell *matHeaderCellDef  class="custom-header">
                {{ "adt.genderAge" | translate }}
              </th>
              <td mat-cell *matCellDef="let element" [ngClass]="{'vip-background': element.isVip}">
                <div class="cell-content">
                  <img src="./assets/images/{{ element.patientImage }}" alt="image" class="patient-image" />
                  <div class="patient-details">
                    <strong class="Age-font">{{ element.PatientAge }}</strong>
                    <span>{{ element.age }}</span>
                  </div>
                </div>
              </td>            
            </ng-container>
      
            <ng-container matColumnDef="mrn">
              <th mat-header-cell *matHeaderCellDef  class="custom-header">
                {{"EncounterPage.Patient" |translate}}
              </th>
              <td mat-cell class="col-nowrap" *matCellDef="let element" 
              [ngClass]="{
                'vip-background': element.isVip,
                'long-name': element.patientName.length > 25
              }"
              >
                <div>
                  <div class="name-div">
                  <strong class="name-container">{{ element.patientName }}</strong><br>
                  </div>
                  <span class="doctor-name">{{ element.mrnNumber }}</span>
                </div>
              </td>
            </ng-container>
      
            <ng-container matColumnDef="reason">
              <th mat-header-cell *matHeaderCellDef class="custom-header">
               {{"adt.Reason"|  translate}}
              </th>
             <td mat-cell *matCellDef="let element">
            <span>
              {{ element.status }}
            </span>
          </td>
            </ng-container>
      
            <ng-container matColumnDef="Appointmentdetails">
              <th mat-header-cell *matHeaderCellDef class="custom-header">
                {{"EncounterPage.appointmentDetails" | translate}}
              </th>
              <td mat-cell class="col-norwap" *matCellDef="let element">
                <strong  class="Age-font">{{ element.appointmentDate | date : "dd/MM/yyyy hh:mm aa"  }}</strong><br>
                <span>({{ element.patientType  }})</span>
              </td>
            </ng-container>
      
            <ng-container matColumnDef="mobileNo">
              <th mat-header-cell *matHeaderCellDef class="custom-header">{{ "adt.handphoneNo" | translate}}</th>
              <td mat-cell  *matCellDef="let element">
                <div>
                  <span class="Age-font"> {{ element.countryCode}}</span>&nbsp;
                  <span> {{ element.mobileNo}}</span>
                 
                </div>
              </td>
            </ng-container>
      
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="custom-header">
                {{"EncounterPage.ActionStatus" |translate}}
              </th>
              <td mat-cell class="col-norwap" *matCellDef="let element">
                <div class="image-container">
                  <button
          mat-mini-fab
          class="btnRed"
          type="button"
          data-automation-attribute="button-cancel-dialog"
          matTooltip="{{ 'AppointmentListPage.cancelAppointment' | translate }}"
          (click)="cancelAppt('cancel',element)"
        >
          <mat-icon >event_busy</mat-icon>
        </button>
        &nbsp;
        <button
          mat-mini-fab
          class="btnCyan"
          type="button"
          data-automation-attribute="button-cancel-dialog" matTooltip="{{ 'AppointmentListPage.rescheduleAppointment' | translate }}"
          (click)="cancelAppt('reschedule',element)"
        >
          <mat-icon>update</mat-icon>
        </button>
                </div>
              </td>
            </ng-container>
      
              <!-- <ng-container matColumnDef="Appno">
                <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.appointmentNo" | translate }}</th>
                <td
                  mat-cell
                  class="col-norwap"
                  *matCellDef="let element; let index = index"
                >
                  {{ element.appNo }}
                </td>
              </ng-container> -->
        
            <!-- <ng-container matColumnDef="AppointmentDate">
        <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.appointmentOn" | translate }}</th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          {{ element.appointmentDate | date: "dd/MM/yyyy hh:mm aa" }}
        </td>
      </ng-container> -->
      <!-- <ng-container matColumnDef="PatientType">
        <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.patientType" | translate }}</th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          {{ element.patientType }}
        </td>
      </ng-container> -->
      <!-- <ng-container matColumnDef="MRN">
        <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.mrntrn" | translate }}</th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          {{ element.mrnNumber }}
        </td>
      </ng-container> -->
      <!-- <ng-container matColumnDef="Patient">
        <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.patientName" | translate }}</th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          <img
            class="encounter-patient-img"
            src="../../../assets/images/sidebar-icons/Registration.png"
          />
          {{ element.patientName }}
        </td>
      </ng-container> -->
      <ng-container matColumnDef="PatientDeatils">
        <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.Gender/Age" | translate }}</th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          {{ element.PatientGender }}
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="mobileNo">
        <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.mobileNo" | translate }}</th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          {{ element.mobileNo }}
        </td>
      </ng-container> -->
      <ng-container matColumnDef="bookingType">
        <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.bookingType" | translate }}</th>
        <td
          mat-cell
          class="col-norwap"
          *matCellDef="let element"
          class="capitalizeAll"
        >
          {{ element.bookingType }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Speciality">
        <th mat-header-cell *matHeaderCellDef>{{ "AppointmentPage.specialty" | translate }}</th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          {{ element.specialty }}
        </td>
      </ng-container>
              <!-- <ng-container matColumnDef="Doctor">
                <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.docModECH" | translate }}</th>
                <td mat-cell class="col-norwap" *matCellDef="let element">
                  {{ element.doctorName }}
                </td>
              </ng-container> -->
      
              <ng-container matColumnDef="Reason">
                <th mat-header-cell *matHeaderCellDef>{{ "payerInfo.reason" | translate }}</th>
                <td mat-cell *matCellDef="let element" class="capitalize">
                    {{ element.status }}
                  </td>
              </ng-container>
              <!-- <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.action" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  <div class="status-div"></div>
                  <button
          mat-mini-fab
          class="btnRed"
          type="submit"
          data-automation-attribute="button-cancel-dialog"
        >
          <mat-icon
            matTooltip="{{ 'AppointmentListPage.cancelAppointment' | translate }}"
            (click)="cancelAppt('cancel',element)"
            >event_busy</mat-icon
          >
        </button>
        &nbsp;
        <button
          mat-mini-fab
          class="btnCyan"
          type="submit"
          data-automation-attribute="button-cancel-dialog"
        >
          <mat-icon
            matTooltip="{{ 'AppointmentListPage.rescheduleAppointment' | translate }}"
            (click)="cancelAppt('reschedule',element)"
            >update</mat-icon
          >
        </button>
                </td>
              </ng-container> -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; let i = index; columns: displayedColumns"
                (click)="getIndex(i, row)"
                class="mat-row {{ selectedRow == i ? 'row-hightlighted' : '' }}"
                style="cursor: pointer"
              ></tr>
            </table>
      
            <div class="center" *ngIf="dataSource.data.length == 0">
              {{ "AppointmentListPage.noappointment" | translate }}
            </div>
          </div>
          <!-- <mat-paginator
            [length]="totalDataLength"
            [pageSize]="pageSize"
            (page)="getNext($event)"
            #paginator
            [pageSizeOptions]="paginatorOptions"
          >
          </mat-paginator> -->
    </mat-drawer-content>
</mat-drawer-container>
<div class="footer-container">
  <app-footer
  [showFooter]="true"
  [totalDataLength]="totalDataLength"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [paginatorOptions]="paginatorOptions"
  (pageChange)="getNext($event)"
  (refresh)="refreshSearch()">
  </app-footer>
  </div>